module.exports = __webpack_public_path__ + "img/soleil.7f5566e.jpg";